import React from 'react';
import Table from './Table';
import {Tabs, Tab, Alert, Button} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {isEdge, browserVersion} from 'react-device-detect'
import LeftMenu from './LeftMenu/LeftMenu';
import RightMenu from './RightMenu';
import {activeTable} from './state/activeTable';
import {setSquaresDataWithHash, setSquaresHash} from "./state/tableSquaresState";
import {setCirclesHash} from "./state/tableCirclesState";


class TableContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: this.props.activeKey,
            deprecatedEdgeDismissed: false
        };
        this.handleSelect = (e) => {
            this.setState({
                activeKey: e
            })
        };

        this.setActiveTable = e => {
            if (e.target.id === 'tabs-tab-1') {
                this.props.activeTable('mata-squares')
            }
            else if (e.target.id === 'tabs-tab-2') {
                this.props.activeTable('mata-circles');
            }
        };

        this.checkBrowserAvailability = () => {
            if(this.state.deprecatedEdgeDismissed) {
                return true;
            }

            if (isEdge && browserVersion < 80) {
                return false;
            }

            return true;
        };

        this.dismissBrowserWarning = () => {
            this.setState({deprecatedEdgeDismissed: true});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.activeKey !== this.props.activeKey) {
            this.setState({activeKey: this.props.activeKey})
        }
    }

    componentDidMount() {
        this.props.getHash(this.props.match.params.hash);
    }

    render() {
        return (
            <Route exact path="/mata">
                {!this.checkBrowserAvailability()
                    ? <Alert bsStyle="danger" onDismiss={this.dismissBrowserWarning}>
                        <h4>Strona może działać nieprawidłowo.</h4>
                        <p>
                            Uruchom stronę za pomocą innej przeglądarki lub pobierz najnowszą wersję przeglądarki Edge.
                        </p>
                        <p>
                            <a
                                href="https://www.microsoft.com/edge"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Link do pobrania
                            </a>
                        </p>
                        <p>
                            <Button onClick={this.dismissBrowserWarning}>Ignoruj i przejdź do strony</Button>
                        </p>
                    </Alert>
                    : <div className="d-flex flex-row">
                        <div className="left-menu-container">
                            <LeftMenu mata={this.props.squaresState}/>
                        </div>
                        <div style={{'width': '60%', 'minHeight': '100vh', 'marginBottom': '100px'}}>
                            <Tabs id="tabs" activeKey={this.state.activeKey} onSelect={this.handleSelect} onClick={this.setActiveTable} animation={false}>
                                <Tab eventKey={1} title="Mata 10x10">
                                    <Table mata={this.props.squaresState} namespace="mataSquares"/>
                                </Tab>
                                <Tab eventKey={2} title="Kółka 9x9">
                                    <Table mata={this.props.circlesState} namespace="mataCircles"/>
                                </Tab>
                            </Tabs>
                        </div>
                        <div style={{'width': '17%'}}>
                            <RightMenu/>
                        </div>
                    </div>
                }
            </Route>
        )
    }
}

export default connect(
    state => ({
        active_Table: state.activeTable,
        language: state.language,
        squaresState: state.squaresState,
        circlesState: state.circlesState,
    }),
    {activeTable, setSquaresHash, setCirclesHash, setSquaresDataWithHash}
)(TableContainer)



// WEBPACK FOOTER //
// ./src/TableContainer.js